module.exports = __webpack_public_path__ + "static/media/plank2.17911a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plank2.jpg
// module id = 36
// module chunks = 1